import TextView from '@/components/textview/TextView';

function StatusText({statusText}) {
  return statusText.map((status, i) => (
    <div
      // eslint-disable-next-line react/no-array-index-key
      key={i}
      className="row col-md-12"
    >
      <TextView
        label={status.label}
        value={status.value}
        unit={status.unit}
      />
    </div>
  ));
}

export default StatusText;
